import './mediaCard.scss';
import { Icon } from '@rocketmakers/armstrong';
import * as React from 'react';
import { icons } from '../../content/icons';
import { ImageUtils } from '../../utils/image';
import { Card } from '../layout/card';
import { SoundcloudPlayer } from './soundcloudPlayer';
import { VimeoPlayer } from './vimeoPlayer';
export const MediaCard = ({ media }) => (<Card className="media">
    <h3>{media.title}</h3>
    {!!media.description && <p>{media.description}</p>}
    {!!media.vimeo_id && <VimeoPlayer id={media.vimeo_id}/>}
    {!!media.soundcloud_id && <SoundcloudPlayer id={media.soundcloud_id}/>}
    {!!media.document?.length && (<a href={ImageUtils.getCosmosAssetUrl(media.document?.[0].ticket)} target="_blank" rel="noreferrer noopener">
        <div className="media-document">
          <Icon {...icons.document} className="document"/>
          <Icon {...icons.download} className="download"/>
        </div>
      </a>)}
  </Card>);
